const counters = document.querySelectorAll('.counter');

const runCounter = () => {
  counters.forEach(counter => {
    counter.innerText = "0";
    let target = +counter.getAttribute('data-target');
    let step = target / 200; // speed

    const updateCounter = () => {
      let value = +counter.innerText;

      if (value < target) {
        counter.innerText = Math.ceil(value + step);
        setTimeout(updateCounter, 10);
      } else {
        counter.innerText = target.toLocaleString(); // 10,000 formatting
      }
    };

    updateCounter();
  });
};

let statsSection = document.querySelector(".hero-stats");
let started = false;

window.addEventListener("scroll", function () {
  let sectionTop = statsSection.getBoundingClientRect().top;

  if (sectionTop < window.innerHeight && !started) {
    runCounter();
    started = true;
  }
});
